export default "__VITE_ASSET__wOAtjKDB__"